import { sortByValues } from 'Common/filterValues';
import {
  transformMake,
  transformModel,
  transformTrim
} from 'Common/buildQuery/mapping';
import * as R from 'ramda';

const mappings = {
  make: 'standardMake',
  urlmake: 'standardMake',
  model: 'standardModel',
  trim: 'standardTrim',
  standardDrivetrain: 'standardDrivetrain',
  urlmodel: 'standardModel',
  withinDistance: 'distance',
  fuelType: 'standardFuelType',
  gearBox: 'standardTransmissionType',
  category: 'standardBodyType',
  colour: 'standardColour',
  doors: 'doors',
  seats: 'maxSeats',
  urlcarType: 'derivative.urlcategory',
  yearFrom: 'minManufacturedYear',
  yearTo: 'maxManufacturedYear',
  dealerId: 'dealer.id',
  mileage: 'maxOdometerReadingMiles',
  insuranceGroup: 'maxInsuranceGroup',
  engineSizeFrom: 'minBadgeEngineSizeLitres',
  engineSizeTo: 'maxBadgeEngineSizeLitres'
};

export default form => {
  const formValues = form.values ? form.values : {};

  const getKey = key => mappings[key] || key;
  const valueUrlEncode = k => {
    let value = formValues[k] ? JSON.parse(formValues[k]).key : null;

    if (k === 'make') {
      value = transformMake(value);
    }
    if (k === 'model') {
      value = transformModel(value);
    }
    if (k === 'trim') {
      value = transformTrim(value);
    }

    const key = getKey(k);
    if (key && value) {
      const valueFromJSON = value;
      if (valueFromJSON === null) return '';
      const urlValue =
        R.type(valueFromJSON) === 'String' && !key.includes('.id')
          ? valueFromJSON
          : valueFromJSON;
      return `${encodeURIComponent(key)}=${encodeURIComponent(urlValue)}`;
    }

    return '';
  };

  const sortByUrl = key => {
    const sortByValue = sortByValues.filter(
      _ => _.key === JSON.parse(formValues['sortBy']).key
    )[0];

    return sortByValue.sortBy
      ? `sort=${sortByValue.sortBy}${sortByValue.sort}`
      : '';
  };

  const customUrl = {
    keyword: k => `keywords=${encodeURIComponent(formValues[k])}`,
    postCode: k =>
      formValues.isPostCodeValid
        ? `postcode=${encodeURIComponent(formValues[k])}`
        : '',
    sortBy: k => sortByUrl(),
    isPostCodeValid: () => '',
    advertisingLocation: k =>
      `advertisingLocation=${encodeURIComponent(formValues[k])}`
  };
  const getUrlString = k => {
    const urlFn = customUrl[k] || valueUrlEncode;
    return urlFn(k);
  };

  const urlParts = R.keys(formValues)
    .filter(k => formValues[k] !== null)
    .filter(
      k =>
        !(
          k === 'withinDistance' &&
          formValues.withinDistance &&
          !formValues.isPostCodeValid
        )
    )
    .map(getUrlString)
    .filter(i => i !== '');

  return urlParts.join('&');
};



// WEBPACK FOOTER //
// ./src/Common/getQueryString/index.js